import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-gray-900 text-white font-sans" data-id="element-4162" data-mp="2o0antvtrxne1">
      {/* Header */}
      <header className="bg-black border-b border-gray-800 py-4 px-4" data-id="element-4163" data-mp="2s01kuh9w8zr0">
        <div className="max-w-4xl mx-auto flex items-center gap-4" data-id="element-4164" data-mp="2wzxscqhsv9bb">
          <Link to="/meta-martes" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-4165" data-mp="2wy3535j23542">
            <ArrowLeft className="w-5 h-5" data-id="element-4166" data-mp="36ydhinx9o8i6" />
            <span className="text-sm" data-id="element-4167" data-mp="36x2ewrfk56sn">Volver</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-4168" data-mp="3bpvhp9rgu523">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-4169" data-mp="3fpm5r5ply72x">
          Política de Privacidad
        </h1>

        <div className="text-gray-300 text-sm md:text-base space-y-6 leading-relaxed" data-id="element-4170" data-mp="3krbj4s0aywu6">
          <p data-id="element-4171" data-mp="3ppwh0ks314fg">
            En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
            privacidad. Esta política describe cómo recopilamos, usamos y
            protegemos tu información personal.
          </p>

          <section data-id="element-4172" data-mp="2tpz8khuo04dv">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4173" data-mp="2ttn2vj7xoutn">
              1. Información que Recopilamos
            </h2>
            <p className="mb-4" data-id="element-4174" data-mp="2kr5fv2kgfy5l">
              Recopilamos información que nos proporcionas directamente,
              incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-4175" data-mp="3hg3b0lw49y3a">
              <li data-id="element-4176" data-mp="3dgcdlzc34jps">Nombre y dirección de correo electrónico</li>
              <li data-id="element-4177" data-mp="38okx6hmn7udd">Número de teléfono móvil</li>
              <li data-id="element-4178" data-mp="38n9t0gpacklq">Información de registro del evento</li>
              <li data-id="element-4179" data-mp="33pq48muyopfj">Comunicaciones que mantienes con nosotros</li>
            </ul>
          </section>

          <section data-id="element-4180" data-mp="4z7v9q7vcak9">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4181" data-mp="4zpy55p1dn15">
              2. Uso de la Información
            </h2>
            <p className="mb-4" data-id="element-4182" data-mp="76m4d5zyzyg">Utilizamos tu información para:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-4183" data-mp="j4hztf6m7ai0">
              <li data-id="element-4184" data-mp="j7cjh4ht0rad">
                Proporcionar acceso al masterclass y materiales relacionados
              </li>
              <li data-id="element-4185" data-mp="acy3ezpg9cq7">Enviar comunicaciones sobre el evento</li>
              <li data-id="element-4186" data-mp="acfzdgwjpu7q">
                Enviar mensajes SMS/texto con actualizaciones y recordatorios
              </li>
              <li data-id="element-4187" data-mp="ebx5mcjsqvdy">Mejorar nuestros servicios y contenido</li>
              <li data-id="element-4188" data-mp="dqsej66tu69">Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section data-id="element-4189" data-mp="5emssmrbyy6x">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4190" data-mp="5f6co90jjwnl">
              3. Compartir Información
            </h2>
            <p className="mb-4" data-id="element-4191" data-mp="3nlkpg4n2q0ke">
              No se compartirá información móvil con terceros ni afiliados con
              fines de marketing ni promocionales. Los datos de suscripción y el
              consentimiento para el uso de mensajes de texto no se compartirán
              con terceros.
            </p>
            <p data-id="element-4192" data-mp="3abh90tw8vhi0">
              No vendemos ni compartimos tu información personal con terceros
              para fines de marketing. Podemos compartir información con
              proveedores de servicios que nos ayudan a operar nuestro negocio.
            </p>
          </section>

          <section data-id="element-4193" data-mp="3k355583qxmpt">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4194" data-mp="3fau2hxhmfmtk">
              4. Mensajes SMS/Texto
            </h2>
            <p className="mb-4" data-id="element-4195" data-mp="3tyoxjkj3q39t">
              Al proporcionar tu número de teléfono móvil y dar tu
              consentimiento, aceptas recibir mensajes SMS/texto recurrentes de
              True Marketer LLC, incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-4196" data-mp="6tz8z8mpres5">
              <li data-id="element-4197" data-mp="1wqsrdl4lktj">Actualizaciones del programa</li>
              <li data-id="element-4198" data-mp="1tuprauf85y8">Información de capacitación</li>
              <li data-id="element-4199" data-mp="28mwxis9gjl7a">Mensajes de marketing/promocionales</li>
              <li data-id="element-4200" data-mp="23n2a4yow5dqz">Recordatorios de eventos</li>
            </ul>
            <p className="mt-4" data-id="element-4201" data-mp="23ovfmanrprxe">
              La frecuencia de los mensajes varía. Pueden aplicar tarifas de
              mensajes y datos según tu plan de telefonía móvil.
            </p>
            <p className="mt-4" data-id="element-4202" data-mp="2a1pwy0qxfjg2">
              <strong className="text-white" data-id="element-4203" data-mp="2f2dxbd11pcmy">Para cancelar:</strong> Responde
              STOP a cualquier mensaje para dejar de recibir mensajes SMS.
            </p>
            <p className="mt-2" data-id="element-4204" data-mp="2k0ypcp658q0b">
              <strong className="text-white" data-id="element-4205" data-mp="1mdq7r599k13l">Para ayuda:</strong> Responde HELP
              para obtener asistencia.
            </p>
            <p className="mt-4" data-id="element-4206" data-mp="1rc1j5kf7ijnx">
              El consentimiento para recibir mensajes SMS no es una condición de
              compra.
            </p>
          </section>

          <section data-id="element-4207" data-mp="212ckcz7iaer4">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4208" data-mp="212w2oh12j55o">
              5. Seguridad de Datos
            </h2>
            <p data-id="element-4209" data-mp="13mfjywyu44fx">
              Implementamos medidas de seguridad técnicas y organizativas
              apropiadas para proteger tu información personal contra acceso no
              autorizado, alteración o destrucción.
            </p>
          </section>

          <section data-id="element-4210" data-mp="w3z77bvkpeva">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4211" data-mp="w3g1ctj76gxm">
              6. Tus Derechos
            </h2>
            <p data-id="element-4212" data-mp="r3bi4vqwn83p">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal. Para ejercer estos derechos, contáctanos en:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-4213" data-mp="i3ohwd9ww8c8">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section data-id="element-4214" data-mp="8dlle33l0c95">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4215" data-mp="8ewrwaoevy3y">
              7. Cookies
            </h2>
            <p data-id="element-4216" data-mp="3glig1213pm9">
              Utilizamos cookies y tecnologías similares para mejorar tu
              experiencia en nuestro sitio web y analizar el uso del sitio.
            </p>
          </section>

          <section data-id="element-4217" data-mp="3qk9tm1txhfj1">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-4218" data-mp="3qlum7lwomoe9">Contacto</h2>
            <p data-id="element-4219" data-mp="3fx35a41p3z2a">
              Para preguntas sobre esta política de privacidad, contacta:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-4220" data-mp="3kzalx6xh03ay">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section className="mt-12 pt-8 border-t border-gray-700" data-id="element-4221" data-mp="3bxb4idijmx7h">
            <p className="text-gray-500 text-sm" data-id="element-4222" data-mp="3iak85pjosub">
              Última actualización: Febrero 2025
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-6 px-4" data-id="element-4223" data-mp="3pxc5ru2q06nh">
        <div className="max-w-4xl mx-auto text-center" data-id="element-4224" data-mp="3puzlha9hpk79">
          <p className="text-gray-600 text-xs mb-2" data-id="element-4225" data-mp="3uulzhlx574h4">
            &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-4226" data-mp="r6trqj0rt1lc">
            Soporte:{' '}
            <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-4227" data-mp="r84zsv190vi9">
              support@truemarketer.com
            </a>
          </p>
          <div className="flex items-center justify-center gap-4 text-xs mt-2" data-id="element-4228" data-mp="wjiofmxfbf91">
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-4229" data-mp="1aa40arogmoxf">
              Términos
            </Link>
            <span className="text-gray-600" data-id="element-4230" data-mp="15eoqqbxhjf6t">|</span>
            <span className="text-white" data-id="element-4231" data-mp="hnt3ls3z585w">Privacidad</span>
          </div>
        </div>
      </footer>
    </div>;
}